// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__W8xmq","colMin":"styles_colMin__3cymQ","colCheckbox":"styles_colCheckbox__1Apdh"};